export { default } from './MoreDetailsMobileCollapse';
